<template>
  <v-layout row wrap pa-4 ma-4 class='profile-infantil'>
    <v-flex xs12>
      <h1>{{ $t('profile.ChildProfile') }}</h1>
      <div v-if='!isChild'>
        <br>
        <p>{{ $t('text.messageChildProfile') }}</p>
        <p>{{ $t('text.messagePasswordChildProfile') }}</p>
      </div>
      <div v-if='isChild'>
        <br>
        <p>{{ $t('text.messageDisableChildProfile') }}</p>
        <p>{{ $t('text.messageClearPasswordChildProfile') }}</p>
      </div>

      <v-form v-model='valid' class='mt-4'>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              v-model='form.password'
              :rules='passRules'
              :label="$t('text.Password')"
              required
              class='input-name'
              autocomplete='nope'
              type='number'
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-btn
          type='submit'
          color='primary right'
          v-if='!isChild'
          @click="saveProfile('save', $event)"
          dark
          large
          class='mt-4 mr-0 ml-0'
          :disabled='!isValid'
          :loading='sendingForm'
        >{{ $t('text.activatedChildProfile') }}
        </v-btn>
        <v-btn
          color='primary right'
          type='submit'
          v-if='isChild'
          @click="saveProfile('delete', $event)"
          dark
          large
          class='mt-4 mr-0 ml-0'
          :disabled='!isValid'
          :loading='sendingForm'
        >{{ $t('text.deactivatedChildProfile') }}
        </v-btn>
      </v-form>
    </v-flex>

    <dialog-default
      :show='dialog.show'
      :title='dialog.title'
      :message='dialog.message'
      :ok='dialog.ok'
      v-on:close='dialogClose'
    ></dialog-default>

    <dialog-default
      :show='dialogPassword.show'
      :title='dialogPassword.title'
      :message='dialogPassword.message'
      :ok='dialogPassword.ok'
      v-on:close='dialogClose'
    ></dialog-default>
  </v-layout>
</template>

<script>
import bus from '@/utils/bus';
import DialogDefault from '@/components/dialog/Default';

export default {
  name: 'profile-perfil-infantil',
  components: {
    'dialog-default': DialogDefault
  },
  metaInfo() {
    return {
      title: this.$route.meta.title
        ? 'E-Komics - ' + this.$t(this.$route.meta.title)
        : 'E-Komics'
    };
  },
  data() {
    return {
      dialog: {
        show: false,
        title: 'Oops..',
        message:
          'Dados indisponíveis no momento. Tente novamente em alguns instantes.',
        ok: () => {}
      },

      form: {
        password: ''
      },

      errors: [],
      valid: false,
      passRules: [
        v => !!v || this.$t('errors.numericFieldIsRequired'),
        v => v.length >= 4 || this.$t('errors.passwordMustBeAtLeast4Numbers')
      ],
      dialogPassword: {
        show: false,
        title: 'Senha Incorreta',
        message: 'A senha digitada não confere, tente novamente.',
        ok: () => {}
      }
    };
  },
  computed: {
    profile() {
      return this.$store.getters.profile;
    },
    isChild() {
      return localStorage.getItem('password') === null ? false : true;
    },
    isValid() {
      return this.form.password.length >= 4;
    }
  },
  mounted() {
  },
  methods: {
    dialogClose: function() {
      this.dialog.show = false;
      this.dialogPassword.show = false;
    },
    saveProfile: function(message, event) {
      this.sendingForm = true;
      bus.$emit('loading', true);
      if (message === 'save') {
        localStorage.setItem('password', this.form.password);

      } else {
        if (this.form.password === localStorage.getItem('password')) {
          localStorage.removeItem('password');
        } else {
          event.preventDefault();
          this.dialogPassword.show = true;
        }
      }

      bus.$emit('loading', false);
      this.sendingForm = false;
    }
  }
};
</script>

<style lang='scss'>
@import '../assets/css/_variables';

.profile-infantil {
  @media (min-width: 960px) {
    .input-name {
      padding-right: 20px;
    }
  }
  
  .btn-vinculado-fb {
    margin: 10px 0 0 0;
    
    i {
      top: 3px;
    }
    
    span {
      padding: 10px;
      font-weight: 500;
    }
    
    // .disable{
    // cursor: not-allowed;
    // pointer-events: none;
    // }
    
  }
  
  .p {
    font-weight: lighter;
    font-size: 18px !important;
  }
  
  .v-btn--disabled {
    &.theme--dark.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
      background-color: rgba(158, 73, 73, 0.63) !important;
      color: gray;
      float: right !important;
    }
    
    &.primary--text {
      color: white !important;
    }
  }
}
</style>
